<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <!-- filter button -->
          <v-btn class="mr-2" large v-on="on" :class="{'teal--text':filter.active}">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filter</v-card-title>
            <v-divider />
            <v-card-text>
              <v-text-field
                v-model="filter.data.nama"
                hide-details
                outlined
                dense
                placeholder="Cari berdasar nama"
                label="Nama"
              ></v-text-field>
              <br />
              <v-text-field
                v-model="filter.data.deskripsi"
                hide-details
                outlined
                placeholder="Cari berdasar deskripsi"
                label="Deskripsi"
                dense
              ></v-text-field>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>
      <v-spacer />

      <!-- grid button -->
      <v-btn class="ml-2" color="cyan white--text" large to="/label-konseling/baru">
        <span class="hidden-xs-only" v-text="app.grid.create"></span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- grid -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      multi-sort
      class="elevation-1"
    >
      <template v-slot:item.Color="{ item }">
        <v-chip dark :color="item.Color">{{item.Color}}</v-chip>
      </template>
      <!-- custom updated date & by -->
      <template v-slot:item.LastUpdatedDate="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
          </template>
          <span>{{$format.updatedDate(item)}}</span>
        </v-tooltip>
      </template>

      <!-- grid header -->
      <template v-slot:header.Actions>
        <div class="float-right">
          <v-btn icon v-if="filter.active" :class="{'mr-4':sort.active}" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
          <v-btn icon v-if="sort.active" @click="clearSort">
            <v-icon>mdi-sort-variant-remove</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- grid actions -->
      <template v-slot:item.Actions="{ item }">
        <div class="float-right">
          <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" :loading="item.processing">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="deleteItem(item)">
                <v-list-item-icon>
                  <v-icon color="red">mdi-delete</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Hapus</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      filter: {
        dialog: false,
        active: false,
        data: {
          nama: "",
          deskripsi: ""
        },
        query: {}
      },
      sort: {
        active: false
      },
      search: {
        awaiting: false,
        data: ""
      },
      table: {
        awaiting: false
      },
      loading: false,
      options: {},
      headers: [
        {
          value: "Name",
          text: "Nama",
          width: "15%"
        },
        {
          value: "Description",
          text: "Deskripsi",
          width: "30%"
        },
        {
          value: "Color",
          text: "Warna",
          width: "20%"
        },
        {
          value: "LastUpdatedDate",
          text: "Terakhir Diubah",
          width: "20%"
        },
        {
          value: "Actions",
          sortable: false,
          width: "15%"
        }
      ],
      items: [],
      totalItems: 0
    };
  },
  computed: {
    ...mapState({
      app: state => state.app
    })
  },
  methods: {
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;
      payload.KeywordFields = ["Name", "Description"];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);

      this.$axios
        .post("/discussion/label/list", payload)
        .then(res => {
          const result = res.data;

          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async editItem(item) {
      this.$router.push(`label-konseling/${item.ID}`);
    },

    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        item.processing = true;
        this.$axios
          .delete(`/discussion/label/${item.ID}`)
          .then(res => {
            if (res.data.Success) {
              this.$dialog.notify.success(res.data.Message, {
                ...this.app.notification
              });
            }
            this.getItems();
          })
          .catch(error => {
            this.$dialog.notify.error(error, {
              position: this.app.notification.position
            });
          })
          .finally(() => {
            item.processing = false;
          });
      }
    },
    doFilter() {
      let filter = new this.$dbflex();
      let data = this.filter.data;
      filter.eq("Name", data.nama);
      filter.eq("Description", data.deskripsi);

      let query = filter.get();
      if (query) {
        this.filter.dialog = false;
        this.filter.active = true;
        this.filter.query = query;
        this.search.data = "";
        this.getItems();
      }
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = null;
      this.search.data = "";
      this.getItems();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    }
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },
      deep: true
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    }
    // "filter.data": {
    //   handler: function(newVal, oldVal) {
    //     console.log(">>>", this);
    //     console.log(">>>", newVal, oldVal, newVal == oldVal);
    //   },
    //   deep: true
    // }
  },
  mounted() {}
};
</script>

<style lang="scss">
</style>